import { ResourceDetail } from '@cibo/core'
import Done from '@mui/icons-material/Done'
import Error from '@mui/icons-material/Error'
import { flatten, pipe, pluck, propEq, uniq } from 'ramda'
import { ReasonsPopper } from './ReasonsPopper'
import { useBenchmarkTest } from './useBenchmarkTest'

type TestResultsProps = {
  details: ResourceDetail[]
}

export const TestResults = ({ details }: TestResultsProps) => {
  const testResults = useBenchmarkTest(details)

  const allBenchmarks = pipe(
    pluck('benchmarks'),
    flatten,
    // @ts-ignore
    pluck('benchmark'),
    uniq
    // @ts-ignore
  )(testResults.data || []) as string[]

  return (
    !!testResults.data && (
      <table style={{ border: '1px solid grey', opacity: testResults.isFetching ? 0.3 : 1 }}>
        <thead>
          <tr>
            <th>program</th>
            {allBenchmarks.map(benchmark => (
              <th key={benchmark}>{benchmark}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {testResults.data.map(result => (
            <tr key={result.programId}>
              <td>{result.programId}</td>
              {allBenchmarks.map(benchmark => {
                const status = result.benchmarks.find(propEq('benchmark', benchmark))

                return (
                  <td>
                    {!!status?.reasons && (
                      <ReasonsPopper
                        reasons={status.reasons}
                        Icon={
                          status?.status === 'pass'
                            ? () => <Done color="success" />
                            : status?.status === 'fail'
                            ? () => <Error color="error" />
                            : undefined
                        }
                      />
                    )}
                  </td>
                )
              })}
            </tr>
          ))}
        </tbody>
      </table>
    )
  )
}
